<template>
  <div>
  
    <iModal
      :title="buttonSize=='PhoneRadio'?'绑定新手机':'绑定新邮箱'"
      :closable="false"
      :mask-closable="false"
      v-model="show"
      width="500px"
     :styles="{top: '200px'}"
      @on-visible-change="changeValidType2"
    >
    <div style="text-align: center;">
     <RadioGroup v-model="buttonSize" type="button" >
            <Radio label="PhoneRadio">手机号</Radio>
            <Radio label="EmailRadio">邮箱</Radio>
        </RadioGroup>
        </div>
      <div class="account-add"  >
        <!-- <p v-if="validType === 0">绑定新手机</p>
        <p v-if="validType === 1">验证旧手机</p>
        <p v-if="validType === 2">用新手机绑定旧手机</p> -->
        
        <div class="account-add-content">
          <Form
            ref="formInline2"
            :model="formInline2"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="新手机：" prop="mobile" v-if="buttonSize == 'PhoneRadio'">
              <Input type="text" v-model="formInline2.mobile" placeholder="请输入手机号码" />
            </FormItem>
            <FormItem label="验证码：" class="form-code-item" prop="captcha" v-if="buttonSize == 'PhoneRadio'">
              <Row>
                <Col span="14">
                  <Input type="text" v-model="formInline2.captcha" placeholder="请填写验证码" />
                </Col>
                <Col span="8" push="2">
                  <Button
                    v-if="showCode"
                    @click="getCaptcha('formInline2')"
                    style="width: 100%;"
                  >获取验证码</Button>
                  <Button v-else disabled style="width: 100%;">{{count}}s后重新获取</Button>
                </Col>
              </Row>
            </FormItem>

             <FormItem label="新邮箱：" prop="email" v-if="buttonSize == 'EmailRadio'">
              <Input type="text" v-model="formInline2.email" placeholder="请输入新邮箱" />
            </FormItem>
            <FormItem label="验证码：" class="form-code-item" prop="captcha" v-if="buttonSize == 'EmailRadio'" >
              <Row>
                <Col span="14">
                  <Input type="text" v-model="formInline2.captcha" placeholder="请填写验证码" />
                </Col>
                <Col span="8" push="2">
                  <Button
                    v-if="showCode"
                    @click="getCaptcha('formInline2')"
                    style="width: 100%;"
                  >获取验证码</Button>
                  <Button v-else disabled style="width: 100%;">{{count}}s后重新获取</Button>
                </Col>
              </Row>
            </FormItem>

          </Form>
        </div>
      </div>


     

      <div slot="footer">
        <Button type="primary" :loading="loading2" @click="bind('formInline2')">绑定</Button>
      </div>
     

   
     

    </iModal>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "changePhone",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        buttonSize:"PhoneRadio",
      loading: false,
      loading2: false,
      showModal: false,
      showModal2: false,
      phone: "", // 原手机号
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      oldTel: "",
      adminInfo: null, // 管理员信息
      formInline: {
        // form双向绑定
        mobile: "",
        captcha: ""
      },
      formInline2: {
        // form双向绑定
        mobile: "",
        email: "",
        captcha: ""
      },
      ruleInline: {
        // 效验规则
        mobile: validator.phone,
        email: validator.email,
        captcha: [
          {
            required: true,
            message: "验证码为必填选项",
            trigger: "blur"
          }
        ]
      },
      validType: 0, // 三种状态 0：绑定新手机  1：验证原手机 2：绑定新手机
      firstToken: '', // 验证新手机之前的旧手机
    };
  },
  watch: {
    show(val, oldVal) {
    //   if (!this.phone) {
    //     debugger
    //     this.showModal2 = val;
    //   } else {
    //     this.showModal = val;
    //   }
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      user: "getUser"
    })
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getStaffByCompId: "companyModule/getStaffByCompId", 

      changePhoneToken: "companyModule/changePhoneToken", // （原手机不为空） 新手机发送验证码
      changePhoneOldToken: "companyModule/changePhoneOldToken", // （原手机不为空） 发送验证码
      changePhoneApply: "companyModule/changePhoneApply", // （原手机不为空） 验证并更改手机
      changePhoneOldCheck: "companyModule/changePhoneOldCheck", // （原手机不为空） 验证手机验证码（省略）
       bindPhoneToken: "companyModule/bindPhoneToken", // （原手机为空） 发送验证码
      bindPhoneApply: "companyModule/bindPhoneApply", // 验证并更改手机 绑定手机（原手机为空）

       changeEmailToken: "companyModule/changeEmailToken", // （原邮箱不为空） 新邮箱发送验证码
      changeEmailOldToken: "companyModule/changeEmailOldToken", // （原邮箱不为空） 发送验证码
      changeEmailApply: "companyModule/changeEmailApply", // （原邮箱不为空） 验证并更改邮箱
      changeEmailOldCheck: "companyModule/changeEmailOldCheck", // （原邮箱不为空） 验证邮箱验证码（省略）
       bindEmailToken: "companyModule/bindEmailToken", // （原邮箱为空） 发送验证码
      bindEmailApply: "companyModule/bindEmailApply" // 验证并更改邮箱 绑定邮箱（原邮箱为空）
    }),
      ...mapActions({
      getUser: "loginModule/getUser",
    }),


    async init() {
      this.adminInfo = this.user;
    //   this.phone = this.user.phoneNumber;
    //   if (!this.phone) {
    //     this.validType = 0;
    //   }
      // let arr = []; 
      // let staffArr = await this.getStaffByCompId(this.company.id);
      // staffArr.forEach(c => {
      //   if (c.roleId === 1) {
      //     this.adminInfo = c;
      //     this.phone = c.phoneNumber;
      //     if (!this.phone) {
      //       this.validType = 0;
      //     }
      //   }
      // });
    },
    async bind() {
         let valid = await this.validForm('formInline2');
      if (!valid) return; 

if(this.buttonSize == 'PhoneRadio'){

    // 绑定手机
    if (this.validType === 0) {
      this.bindNewPhone();
    }
    if (this.validType === 2) {
      this.bindNewPhoneByOldPhone();
    }
}else{
    if (this.validType === 0) {
        this.bindNewEmail();
      }
      if (this.validType === 2) {
        this.bindNewEmailByOldEmail();
      }
}
    },
    async bindNewPhone() {
      // 绑定新手机
      let valid = await this.bindPhoneApply({
        UserId: this.adminInfo.id,
        NewPhoneNumber: this.formInline2.mobile,
        token: this.formInline2.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        // this.$Message.error('验证码错误！');
        this.$Message.error(valid.errors[0].description);
        return;
      }
      this.$Message.success("绑定成功!");
      this.cancel();
    },
    async bindNewPhoneByOldPhone() {
      // 通过旧手机绑定新手机
      let valid = await this.changePhoneApply({
        UserId: this.adminInfo.id,
        OldPhoneNumber: this.phone,
        NewPhoneNumber: this.formInline2.mobile,
        token: this.formInline2.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        this.$Message.error('验证码错误！');
        // this.$Message.error(valid.errors[0].description);
        return;
      }
      this.$Message.success("绑定成功!");
      this.cancel();
    },
     async bindNewEmail() {
      // 绑定新邮箱
      let valid = await this.bindEmailApply({
        UserId: this.adminInfo.id,
        NewEmail: this.formInline2.email,
        token: this.formInline2.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        this.$Message.error(valid.errors[0].description);
        return;
      }
      this.init();
      this.$Message.success("绑定成功!");
      this.cancel();
    },
    async bindNewEmailByOldEmail() {
      // 通过旧邮箱绑定新邮箱
      let valid = await this.changeEmailApply({
        UserId: this.adminInfo.id,
        OldEmail: this.email,
        NewEmail: this.formInline2.email,
        token: this.formInline2.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        this.$Message.error(valid.errors[0].description);
        return;
      }
      this.$Message.success("绑定成功!");
      this.cancel();
    },
    async next() {
      let form = this.formInline;
      let valid = await this.validForm('formInline');
      if (!valid) return; 
      let bool = await this.changePhoneOldCheck({
        UserId: this.adminInfo.id,
        OldPhoneNumber: this.formInline.mobile,
        token: this.formInline.captcha
      }); 
      if (!bool) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (!bool.successed) {
        
        this.$Message.error('验证码错误！');
        // this.$Message.error(valid.errors[0].description);
        this.formInline.captcha = "";
        return;
      }
      this.firstToken = this.formInline.captcha;
      this.$Message.success("验证成功!");
      // 验证原手机通过 跳到下一步
      this.showModal = false;
      this.showCode = true;
      clearInterval(this.timer);
      this.timer = null;
      this.formInline.captcha = "";
      this.formInline.captcha2 = "";
      this.showModal2 = true;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    
    getCaptcha(name) {
        if(this.buttonSize == 'PhoneRadio'){
      this.$refs[name].validateField("mobile", val => {
        if (val !== "") return;
        this.downTime(name);
      });
    }else{
        this.$refs[name].validateField("email", val => {
        if (val !== "") return;
        this.downTimeEmail(name);
      });
    }

     
      
    },
    async downTime(name) {
      let valid = null;
      if (this.validType === 0) {
        // 绑定新手机
        valid = await this.bindPhoneToken({
          UserId: this.adminInfo.id,
          NewPhoneNumber: this.formInline2.mobile
        });
      }
    //   if (this.validType === 1) {
    //     // 验证原手机
    //     valid = await this.changePhoneOldToken({
    //       UserId: this.adminInfo.id,
    //       OldPhoneNumber: this.formInline.mobile 
    //     });
    //   }
    //   if (this.validType === 2) {
    //     // 绑定新手机
    //     valid = await this.changePhoneToken({
    //       UserId: this.adminInfo.id,
    //       OldPhoneNumber: this.phone,
    //       NewPhoneNumber: this.formInline2.mobile,
    //       token: this.firstToken
    //     });
    //   }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    }, 

      async downTimeEmail() {
      let valid = null;
      if (this.validType === 0) {
        // 绑定新邮箱
        valid = await this.bindEmailToken({
          UserId: this.adminInfo.id,
          NewEmail: this.formInline2.email,
        });
      }
    //   if (this.validType === 1) {
    //     // 验证原邮箱
    //     valid = await this.changeEmailOldToken({
    //       UserId: this.adminInfo.id,
    //       OldEmail: this.formInline.email
    //     });
    //   }
    //   if (this.validType === 2) {
    //     // 绑定新邮箱
    //     valid = await this.changeEmailToken({
    //       UserId: this.adminInfo.id,
    //       OldEmail: this.email,
    //       NewEmail: this.formInline2.email,
    //       token: this.firstToken
    //     });
    //   }
      if (!valid.successed) {
        if (valid.msg) {
          this.$Message.error(valid.msg);
        } else {
          this.$Message.error(valid.errors[0].description);
        } 
        return false;
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    cancel() {
      this.show = false;
      this.getUser()

      this.showModal = false;
      this.showModal2 = false;
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      if (this.$refs["formInline2"]) {
        this.$refs["formInline2"].resetFields();
      }
      this.firstToken = '';
      this.$emit("finish");
      this.$emit("close");
    },
    changeValidType2(bool) {
      if (bool) {
        if (!this.phone) {
          this.validType = 0; // 绑定新手机
        } else {
          this.validType = 2; // 用新手机绑定旧手机
        }
      }
    },
    changeValidType(bool) {
      if (bool) {
        this.validType = 1; // 验证旧手机
      }
    }
  }
};
</script>

<style scoped lang="scss">
.account-add {
  padding-right: 20px;
  padding-top: 20px;
}

.ivu-radio-group-button .ivu-radio-wrapper-checked{
    color:#d13119
}
.ivu-radio-group-button .ivu-radio-wrapper-checked{
        border-color: #d13119;
        box-shadow: -1px 0 0 0 #d13119;
}
.ivu-radio-group-button .ivu-radio-wrapper:hover{
      color:#d13119
}
</style>

